class AccordionBlock {
    constructor(element) {
        this.accordionBlock = element;
        this.accordionItems = Array.from(this.accordionBlock.querySelectorAll('.services-button'));
        this.addEventListeners();
    }

    addEventListeners() {
        this.accordionItems.forEach(accordionItem => {
            const accordionItemHeader = accordionItem.querySelector('.services-button-top');
            accordionItemHeader.addEventListener('click', this.toggleAccordionItem.bind(this));
        });
    }

    toggleAccordionItem(event) {
        const accordionItem = event.currentTarget.parentElement;
        const accordionContentIsOpen = accordionItem.classList.contains('active');

        if (accordionContentIsOpen) {
            accordionItem.classList.remove('active');
        } else {
            accordionItem.classList.add('active');
        }
    }
}

const accordionBlocks = document.querySelectorAll('[data-accordion-block]');
accordionBlocks.forEach(accordionBlock => {
    new AccordionBlock(accordionBlock);
});